import React from "react";
import CustomTablePDF from "../../Common/CustomTablePDF";
import { View } from "@react-pdf/renderer";

const CargoPdf = (props) => {
  const { query, portOperations, pdfSaveId = "" } = props;
  const { qtyMode = "" } = query || {};

  let showMinMax = false;
  if (qtyMode === "MINMAX") showMinMax = true;

  const data = portOperations?.map((portDetails) => ({
    operation: portDetails.operation,
    port: portDetails.port,
    cargoQty: portDetails.cargoQty.toString(),
    tolerance: portDetails.tolerance.toString(),
    rate: portDetails.rate.toString(),
    terms: portDetails.terms,
    turnTime: portDetails.turnTime.toString(),
    freight: portDetails.freight,
    min: portDetails.min.toString(),
    max: portDetails.max.toString(),
    adcom: portDetails.adcom.toString(),
    other: portDetails.other.toString(),
    brokerage: portDetails.brokerage.toString(),
    account: portDetails.account,
    cargo: portDetails.cargo,
    stowFactor: portDetails.stowFactor.toString(),
  }));
  const fields = [
    { title: "Operation", value: "operation", width: 8 },
    { title: "Port", value: "port", width: 13 },
    { title: "Min", value: "min", width: 6, hide: !showMinMax },
    { title: "Max", value: "max", width: 6, hide: !showMinMax },
    { title: "Cargo Qty", value: "cargoQty", width: 7, hide: showMinMax },
    { title: "Tol(%)", value: "tolerance", width: 5, hide: showMinMax },
    { title: "Rate MT/D", value: "rate", width: 7 },
    { title: "Terms", value: "terms", width: 8 },
    { title: "Turn(D)", value: "turnTime", width: 5 },
    { title: "Freight", value: "freight", width: 6 },
    { title: "Adcom%", value: "adcom", width: 6 },
    { title: "Other%", value: "other", width: 6 },
    { title: "Broker%", value: "brokerage", width: 6 },
    { title: "Counter Party", value: "account", width: 8 },
    { title: "Cargo Name", value: "cargo", width: 8 },
    { title: "Stow Factor", value: "stowFactor", width: 7 },
  ];

  return (
    <View>
      <CustomTablePDF fields={fields} data={data} query={query} pdfSaveId={pdfSaveId} />
    </View>
  );
};

export default CargoPdf;
